import React, { useState, useEffect, useRef, useContext } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { BiSolidEditAlt } from 'react-icons/bi';
import { IoNewspaperOutline, IoSearchSharp } from 'react-icons/io5';
import { CiEdit } from 'react-icons/ci';
import { MdDeleteForever } from 'react-icons/md';
import { FaEdit, FaRegWindowClose } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Link } from 'react-router-dom';
import { SiInstructure } from 'react-icons/si';
import axios from 'axios';
import Select from 'react-select/async';
import { DataContext } from '../context/DataProvider';
import { Editor } from '@tinymce/tinymce-react';
import SearchLawDropDown from '../SearchableDropDown/SearchLawDropDown';
// import signalR from"@microsoft/signalr";
// import { HubConnectionBuilder } from '@microsoft/signalr';

import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { format as jalaliFormat } from 'date-fns-jalali';
import tickIMG from '../images/icon/icons8-tick-96.png';
import LawType from '../SearchableDropDown/LawType';
import EditReform from './ModalComponents/EditReform';
const NewReform = () => {
  const [fromDate, setfromDate] = useState();
  const [AIstructureLoading, setAIstructureLoading] = useState(false);
  const [RevisionRistrict, setRevisionRistrict] = useState(true);
  const [AllStatus, setAllStatus] = useState([]);

  const [ToDate, setToDate] = useState();
  const handlefromDate = (date: Date) => {
    setfromDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
  };
  const handleToDate = (date: Date) => {
    setToDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
  };
  const isReplatedChecked = async (e) => {
    console.log(e.target.checked);
    setIsReplated(e.target.checked);
  };
  const signalR = require('@microsoft/signalr');

  const [savePage, setSavePage] = useState(1);
  const {
    tokenLogin,
    isTokenExpired,
    fetchRefreshToken,
    edame,
    ReformInfo,
    setReformInfo,
    OptionSearch,
    setOption,
    fetchLops,
    ReFormEditFun,
    openEdiModal,
    setOpenEditModal,
    OpenCreateModal,
    setOpenCreateModal,
    openDeleteModalReform,
    setOpenDeleteModalReform,
    deleteID,
    setDeleteID,
    Lops,
  } = useContext(DataContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const [OpenModalAIRestructure, setOpenModalAIRestructure] = useState(false);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: number | any = searchParams.get('page');
  const [listSection, setListSection] = useState({});
  const [loading, setLoading] = useState(false);
  // const [openEdiModal, setOpenEditModal] = useState(false);
  const [searchbox, setSearchBox] = useState('');
  const [SearchResult, setSearchResult] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  // const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const [deleteID, setDeleteID] = useState(0);
  // const [Lops, setLops] = useState([]);
  const [pageSize, setPageSize] = useState(30);
  const [EditTextModal, setEditTextModal] = useState(false);
  const [TextEdit, setTextEdit] = useState({});
  const [EditTextObj, setEditTextObj] = useState({});
  // const [OpenCreateModal, setOpenCreateModal] = useState(false);
  const [sectionType, setSectionType] = useState([]);
  const [obj, setObj] = useState({});
  const [isReplated, setIsReplated] = useState(false);
  let rowNumber = page ? (page - 1) * pageSize : 0;
  const [Message, setMessage] = useState([]);
  const [AIShowAlarm, setAIShowAlarm] = useState(false);
  const [OrderCensitive, setOrderCensitive] = useState(true);
  const [connection, setConnection] = useState<null | String>(null);
  const [connectionStatus, setConnectionStatus] = useState('');

  // const SignalRFun = async () => {
  //   if(connection!==null){

  //   }

  // };

  // useEffect(() => {
  //   if(connection){
  //     }
  //   // if(connectionStatus==='Disconnected'){
  //   //   setAIShowAlarm(true)
  //   //   setMessage('عملیات ساختاربندی مجدد هوشمند، کدگذاری هوشمند و ثبت اطلاعات تنقیحی با موفقیت پایان پذیرفت')

  //   //  }

  // },[connection])

  function deHilight(str: string) {
    return str
      .replaceAll(/\n/g, ' ')
      .replaceAll('</e>', ' ')
      .replaceAll('</b>', ' ')
      .replaceAll('<e>', ' ')
      .replaceAll('<b>', ' ')
      .replaceAll('\x9D', '  ')
      .replaceAll(' ', '  ');
  }
  // const loadOptions = async (inputValue, callback) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_BASE_URL}/api/Admin/ListLaw?search=${inputValue}`,

  //     )
  //     console.log(response.data.data)
  //     const options = response.data.data.map((item) => ({
  //       value: item.ID,
  //       label: item.Title + ' ' + 'مصوب:' + item.ApproveDate.split('/')[0],
  //     }))
  //     callback(options)
  //   } catch (error) {
  //     console.error('Error fetching options:', error)
  //   }
  // }
  // const FetchListSection = async (pageNumber: number) => {
  //   await fetch(
  //     `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?size=${pageSize}&page=${pageNumber}`,
  //   )
  //     .then((res) => res.json())
  //     .then((data) => setListSection(data))
  //     .finally(() => setLoading(false));
  // };
  let x;
  const fetchSectionType = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/SectoinType`)
      .then((res) => res.json())
      .then((data) => setSectionType(data));
  };
  const OnClickEdit = (item: {}) => {
    fetchLops(item.Law_ID);
    // x = sectionType.find((t) => t.ID == item.SectionType_ID)
    console.log('X', x);
    console.log('item.SectionType_ID', item.SectionType_ID);
    setReformInfo({
      ...ReformInfo,
      ID: item.ID,
      Law_ID: item.Law_ID,
      Parent_ID: item.Parent_ID === null ? '' : item.Parent_ID,
      SectionText: item.SectionText,
      Title: item.Title,
      SectionType_ID: item.SectionType_ID,
      TextOrder: item.TextOrder,
      SectionNumber: item.SectionNumber,
      LetterNumber: item.LetterNumber,
      SectionPath: item.SectionPath,
      ChangeDate:
        item.ChangeDate !== '' || item.ChangeDate !== null
          ? item.ChangeDate
          : '',
      TextOrder2: item.TextOrder2,
      Status: item.Status_ID,
      // RevisionRistrict:item.RevisionRistrict,
      // SectionTitle: x.Title,
      TextForEdit: '',
    });
    setOpenEditModal(true);
  };
  // console.log(ReformInfo);
  // const fetchLops = async (id: number) => {
  //   try {
  //     await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?search=${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${tokenLogin?.AccessToken}`,
  //         },
  //       },
  //     )
  //       .then((res) => res.json())
  //       .then((data) => setLops(data.data))
  //       .finally(() => setLoading(false));
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // };
  const Search = async () => {
    // console.log("####",OptionSearch)
    // ${fromDate!==null && fromDate!==undefined ?`&fromDate=${fromDate}`:""}${ToDate!==null && ToDate!==undefined ?`&toDate=${ToDate}`:""}&lawtype=${Type!==8?Type:8}
    if (OptionSearch.value !== 0) {
      try {
        await fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/Admin/ListSection?page=${pageNumber}&size=${pageSize}${
            OptionSearch.value !== 0 ? '&search=' + OptionSearch.value : ''
          }${isReplated ? `&repealed=${isReplated}` : ''}`,
        )
          .then((res) => res.json())
          // .then((data)=>console.log("@@@",data))
          .then((data) => setSearchResult(data))
          .finally(() => setLoading(false));
      } catch (error) {
        console.log('error', error);
      }
    } else {
      setsearchParams({});
      // setSelectedOption(option)
      setSearchResult({});
    }
    //   try {
    //     await fetch(
    //       `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?search=${option.value}&page=${pageNumber}&size=${pageSize}`,
    //     )
    //       .then((res) => res.json())
    //       .then((data) => setSearchResult(data))
    //       .finally(() => setLoading(false))
    //   } catch (error) {
    //     console.log('error', error)
    //   }
    // }
  };

  const changePageSize = (e) => {
    if (page !== 1 || !page) {
      setsearchParams({});
      setPageSize(parseInt(e.target.value));
    } else {
      setPageSize(parseInt(e.target.value));
    }
  };

  const onChangePage = (data: any) => {
    setsearchParams({ page: data.selected + 1 });

    // FetchListSection(data.selected + 1)
  };
  const onChangePageSearch = (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    setPageNumber(data.selected + 1);
    // Search()
    setSavePage(data.selected + 1);
  };
  const handleDelete = (id: number) => {
    setOpenDeleteModal(true);
    setDeleteID(id);
  };
  const deleteAPI = async () => {
    // console.log(deleteID)
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Admin/DeleteSection?ID=${deleteID}`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            },
          },
        )
          .then((res) => {
            if (res.status === 200) {
              setOpenDeleteModalReform(false);
              setReformInfo({
                ...ReformInfo,
                ID: '',
                Law_ID: '',
                Parent_ID: '',
                SectionText: '',
                Title: '',
                SectionType_ID: '',
                TextOrder: '',
                SectionNumber: '',
                LetterNumber: '',
                SectionPath: '',
                TextForEdit: '',
                RevisionRistrict: true,
                // SectionPath:'',
              });
            }
          })
          .finally(() => setLoading(false));

        // FetchListSection(page ? page : 1)
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchRefreshToken();
    }
  };
  useEffect(() => {
    // console.log(
    //   'selectedOption',
    //   tokenLogin[0] === 'you should go to the login.',
    // )
    // if(OptionSearch.value !==0){
    fetchSectionType();
    Search();
    fetchStatus();
    // }
    // else {
    //   // FetchListSection(page ? page : 1)

    // }
  }, [pageSize, tokenLogin, selectedOption, OptionSearch, page]);

  const EditFun = async () => {
    console.log(ReformInfo.SectionText);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditSection?ID=${ReformInfo.ID}&Law_ID=${ReformInfo.Law_ID}&Parent_ID=${ReformInfo.Parent_ID}&Title=${ReformInfo.Title}&SectionType_ID=${ReformInfo.SectionType_ID}&TextOrder=${ReformInfo.TextOrder}&SectionNumber=${ReformInfo.SectionNumber}&LetterNumber=${ReformInfo.LetterNumber}`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
        'Access-Control-Allow-Headers':
          'X-Requested-With, Content-Type, Authorization',
        'Access-Control-Allow-Credentials': 'true',
      },
      data: JSON.stringify(ReformInfo.SectionText),
    };

    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      console.log('check');
      await axios.request(config).then((response) => {
        console.log(response);
        if (response.status == 200) {
          console.log(response);
          // if (selectedOption !== null) {
          Search(OptionSearch);
          setOpenEditModal(false);
          // } else {
          //   // FetchListSection(page ? page : 1)
          // }
        } else {
          fetchRefreshToken();
        }
      });
    } else {
      fetchRefreshToken();
    }
  };
  const onClickEditText = async () => {
    // if(OptionSearch.value!==0){
    //   setEditTextModal(true);
    //   setEditTextObj(OptionSearch);

    //   await fetch(
    //     `${process.env.REACT_APP_BASE_URL}/api/Admin/PlainText?ID=${OptionSearch.value}`,
    //   )
    //     .then((res) => res.json())
    //     .then((data) => setTextEdit(data))
    //     .catch((error) => {});
    // }
    if (OptionSearch.value === 0) {
      alert('لطفا قانون مورد نظر را از قسمت جستجوی قانون انتخاب کنید ');
    } else {
      setEditTextModal(true);
      setEditTextObj(OptionSearch);

      await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/PlainText?ID=${OptionSearch.value}`,
      )
        .then((res) => res.json())
        .then((data) => setTextEdit(data))
        .catch((error) => {});
    }
  };
  const handleCKEditor = (editor, event) => {
    const data = event.getData();
    console.log(event.getData());
    setReformInfo({
      ...ReformInfo,
      TextForEdit: data,
    });
  };

  const OnChangeCKEitor = (editor, event) => {
    let data = event.getData();
    console.log(event.getData());
    setReformInfo({
      ...ReformInfo,
      SectionText: data,
    });
  };
  const fetchStatus = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Status?all=true`)
      .then((res) => res.json())
      .then((data) => setAllStatus(data));
  };
  // const handleOpenCreateModal = () => {
  //   console.log(selectedOption);
  //   console.log('first');
  //   setOpenCreateModal(true);
  //   setOpenEditModal(false);
  //   setReformInfo({
  //     ID: 0,
  //     Parent_ID: 0,
  //     Law_ID: ReformInfo.Law_ID,
  //     SectionText: '',
  //     Title: '',
  //     SectionType_ID: 0,
  //     TextOrder: 0,
  //     SectionNumber: 0,
  //     LetterNumber: '',
  //     SectionTitle: '',
  //     TextForEdit: '',
  //     RevisionRistrict: true,
  //   });
  // };
  const FetchEditText = async () => {
    //  console.log(editorRef.current.getContent())
    // let data = JSON.stringify(editorRef.current.getData())
    // let data =JSON.stringify(ReformInfo.TextForEdit)
    // console.log(data)
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditText?Law_ID=${OptionSearch.value}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
      },
      data: JSON.stringify(ReformInfo.TextForEdit),
    };

    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      await axios
        .request(config)
        .then((response) => {
          console.log(response);
          // window.location.reload()
          setEditTextModal(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      fetchRefreshToken();
    }

    // await axios({
    //   method: "post",

    //   url: `/api/Admin/EditText?Law_ID=${selectedOption.value}`,
    //   data: JSON.stringify(ReformInfo.TextForEdit),
    //   headers: {
    //     Accept: "application/json",
    //     "Content-Type": "application/json ",
    //   },
    //   maxContentLength: Infinity,
    //   maxBodyLength: Infinity,
    // })
    //   .then(function (response) {
    //     console.log("response", JSON.stringify(response.data))
    //     // setMatn(matn2)
    //   })
    //   .catch(function (error) {
    //     console.log("error", error)
    //   })
  };
  const AIstructure = async () => {
    let arr = [];
    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_BASE_URL}/progressHub`)
      // .withAutomaticReconnect()
      .build();
    newConnection.start().then(() => {
      if (OptionSearch.value == 0) {
        alert('قانون مورد نظر را از قسمت جستجوی قانون  انتخاب کنید');
      } else {
        if (!isTokenExpired(tokenLogin.data?.accessToken)) {
          setAIstructureLoading(true);
          setAIShowAlarm(false);
          try {
            fetch(
              `${process.env.REACT_APP_BASE_URL}/api/Admin/TreeText`,
              // `${process.env.REACT_APP_SIGNALR_BASE_URL}/api/Admin/TreeText2`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
                },
                body: JSON.stringify({
                  id: OptionSearch.value,
                  connectionId: newConnection.connectionId,
                  revisionRistrict: RevisionRistrict,
                  OrderCensitive: OrderCensitive,
                }),
              },
            ).then((res) => res.json());
            //         .catch((err)=>{
            //           setMessage('عملیات ساختاربندی مجدد هوشمند، کدگذاری هوشمند و ثبت اطلاعات تنقیحی با موفقیت پایان پذیرفت')
            // setAIstructureLoading(false)
            //         })
          } catch (error) {
            console.log(error);
          }

          // window.location.assign('/reform')
        } else {
          fetchRefreshToken();
        }
      }
      newConnection.on('ReceiveProgress', (data: any) => {
        if (data.includes('پایان')) {
          setAIstructureLoading(false);
        }
        arr = [...arr];
        arr.push(data);
        console.log('!!!!!!', arr);
        setMessage(arr);
      });
    });
    // return () => {
    //   if (newConnection) {
    //     newConnection.stop();

    //   }
    // };

    // AIstructure();
    //       setConnection(newConnection)
  };
  const createStructure = async () => {
    // console.log(tokenLoginisTokenExpire(tokenLogin?.AccessToken))
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditSection?ID=${ReformInfo.ID}&Law_ID=${ReformInfo.Law_ID}&Parent_ID=${ReformInfo.Parent_ID}&Title=${ReformInfo.Title}&SectionType_ID=${ReformInfo.SectionType_ID}&TextOrder=${ReformInfo.TextOrder}&SectionNumber=${ReformInfo.SectionNumber}&LetterNumber=${ReformInfo.LetterNumber}`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
        'Access-Control-Allow-Headers':
          'X-Requested-With, Content-Type, Authorization',
        'Access-Control-Allow-Credentials': 'true',
      },
      data: JSON.stringify(ReformInfo.SectionText),
    };

    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        await axios
          .request(config)
          .then((response) => {
            console.log(response);
            // setEditTextModal(false)
            window.location.reload();
          })
          .catch((error) => {
            console.log(error);
            //
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      fetchRefreshToken();
    }
  };
  // const handleOpenCreateModal = () => {
  //   console.log(selectedOption)
  //   console.log('first')
  //   setOpenCreateModal(true)
  //   setOpenEditModal(false)
  //   setReformInfo({
  //     ID: 0,
  //     Parent_ID: 0,
  //     Law_ID: ReformInfo.Law_ID,
  //     SectionText: '',
  //     Title: '',
  //     SectionType_ID: 0,
  //     TextOrder: 0,
  //     SectionNumber: 0,
  //     LetterNumber: '',
  //     SectionTitle: '',
  //     TextForEdit: '',
  //   })
  // }
  const [Type, setType] = useState(8);
  const changeType = (e) => {
    if (e.target.value == 'null') {
      setType('null');
    } else {
      setType(e.target.value);
    }
  };
  // const [Connection,setConnection]=useState(0)
  // useEffect(()=>{

  //   setConnection(connection)
  // },[])

  // console.log(SearchResult);

  const OpenModal = () => {
    setMessage([]);
    setAIShowAlarm(true);
    setOpenModalAIRestructure(true);
  };
  if (loading) return <h1>loading.....</h1>;
  const arratest = [
    'عملیات در 21:08:56 شروع شد',
    'عملیات حذف اطلاعات قبلی تکمیل شد',
    'ساختار بندی قانون تکمیل شد',
    'کدگذاری با عبارات منظم تکمیل شد',
    'تنقیح قانون بروز رسانی شد',
    'عملیات ساختاربندی مجدد هوشمند، کدگذاری هوشمند و ثبت اطلاعات تنقیحی با موفقیت پایان پذیرفت.',
  ];
  // if (tokenLogin === '') return window.location.assign('/')
  if (tokenLogin.data == '') {
    localStorage.clear();
    window.location.assign('/');
  }
  console.log('object', ReformInfo);
  const handleChangeDate=(date:{})=>{
      setReformInfo({
        ...ReformInfo,
        ChanegDate:jalaliFormat(new Date(date), 'yyyy/MM/dd')
      })
    }
  return (
    <>
      <Breadcrumb pageName="ساختار بندی و متن قانون" />
      <div className="w-full font-IranSans  max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        {/* search bar */}
        <div className="w-full grid grid-cols-2">
          <div className="w-full rtl ">
            <SearchLawDropDown search={Search} fetchlist={setSearchResult} />
            {/* <Select
              className="w-[80%] text-xl text-black"
              placeholder="جستجوی قانون ...."
              isClearable
              isSearchable
              value={selectedOption}
              onChange={(option) => Search(option)}
              loadOptions={loadOptions}
            /> */}
          </div>
          {/* <div className='w-full flex items-center justify-between '>
            <div className="w-full  md:mt-0 mt-3 flex items-center ">
            <div className='w-full flex items-center  '>
              <label className='ml-3 mr-3'>از </label>
              <DatePicker
                className="custom-calendar"
                inputClass="custom-input"
                calendarPosition="bottom-center"
                value={fromDate}
                locale={persian_fa}
                calendar={persian}
                onChange={handlefromDate}
              />
            </div>
           
          </div>
          <div className="w-full  md:mt-0 mt-3 flex items-center ">
          <div className='w-full flex items-center '>
              <label className='ml-3 mr-3'>تا  </label>
              <DatePicker
                className="custom-calendar"
                inputClass="custom-input"
                calendarPosition="bottom-center"
                value={ToDate}
                locale={persian_fa}
                calendar={persian}
                onChange={handleToDate}
              />
            </div>
          </div>

          <div className="w-[90%] mr-3 md:mt-0 mt-3 flex items-center ">
            <LawType changeTypeFun={changeType}/>
         
          </div>
          <div className="flex w-full items-center mt-3 mb-4 ml-3">
          
          <input
           
            onChange={isReplatedChecked}
            id="default-checkbox"
            type="checkbox"
            value=""
            className="w-7 h-7 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
          />
            <label
            for="default-checkbox"
            className="ms-2 text-sm font-[14px] text-gray-900 dark:text-gray-300 ml-3"
          >
           نمایش همه منسوخه ها 
          </label>
                </div>
          <div className="">
              <button className="button" onClick={Search}>
                <IoSearchSharp size={35} className="svgIcon " />
              </button>
            </div>
            </div> */}
          <div className="w-full ltr">
            <div className="w-full flex ">
              {/* {selectedOption && (
              <Link
                target="_blanck"
                to={`https://ilaws.net/ViewText/${selectedOption.value}`}
              >
                <button className="">
                  <span className="box">مشاهده قانون در سامانه </span>
                </button>
              </Link>
            )} */}

              <button
                onClick={() => {
                  OptionSearch.value !== 0
                    ? OpenModal()
                    : alert(
                        'قانون مورد نظر را از قسمت جستجوی قانون  انتخاب کنید',
                      );
                }}
              >
                <span className="box font-IranSans text-[14px]">
                  ساختاربندی هوشمند
                </span>
              </button>
              <button onClick={onClickEditText}>
                <span className="box font-IranSans text-[14px]">
                  ویرایش متن{' '}
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* table */}
        <div className="w-full overflow-y-auto mt-7">
          <table className="overflow-auto w-full">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  ردیف
                </th>
                <th className="w-[30rem] border-b p-3 text-[14px] text-center">
                  متن ماده / تبصره
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  ساختار
                </th>
              </tr>
            </thead>
            <tbody>
              {SearchResult.success !== true ? (
                <>
                  <tr className="">
                    <td className=""></td>
                    <td className="text-center w-[30rem]">
                      قانون مورد نظر را انتخاب کنید
                    </td>
                    <td></td>
                  </tr>
                  {/* {listSection.data.map((item) => {
                    return (
                      <>
                        <tr className="">
                          <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                           
                            {(rowNumber = rowNumber + 1)}
                          </td>
                          <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans text-justify  ">
                           <Link target='_blank' to={`https://ilaws.net/ViewText/${item.ID}`}>
                           <span
                              dangerouslySetInnerHTML={{
                                __html: item.SectionText,
                              }}
                            ></span>
                           </Link>
                          </td>
                          <td className="w-10  border-b  p-4  text-center   ">
                            <button
                              onClick={() => OnClickEdit(item)}
                              className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                            >
                              {deHilight(item.SectionPath)}
                            </button>
                          </td>
                        </tr>
                      </>
                    )
                  })} */}
                </>
              ) : (
                <>
                  {SearchResult.data.map((item: {}) => {
                    return (
                      <>
                        <tr className="">
                          <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                            {' '}
                            {(rowNumber = rowNumber + 1)}
                          </td>
                          <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans text-justify  ">
                            <Link
                              target="_blank"
                              to={`https://ilaws.net/ViewText/${item.ID}`}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item.SectionText,
                                }}
                              ></span>
                            </Link>
                          </td>
                          <td className="w-10  border-b  p-4 text-[15px] font-IranSans text-center   ">
                            <div
                              onClick={() => OnClickEdit(item)}
                              className="bg-[#38bdf8] w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                            >
                              {deHilight(item.SectionPath)}
                            </div>
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
          {SearchResult.success !== true ? (
            <>
              {/* <div className="w-full flex items-center justify-between font-IranSans ">
                <div className="flex w-full items-center">
                  <label className="text-[15px] items-center">
                    تعداد نمایش در صفحه{' '}
                  </label>
                  <select
                    className="border p-1 mr-3 rounded-lg border-gray-400 outline-none"
                    value={pageSize}
                    onChange={changePageSize}
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>
                <div className="flex items-center justify-center w-full">
                <ReactPaginate
                breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                nextLabel={
                  <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                    <BsChevronLeft />
                  </span>
                }
                onPageChange={onChangePage}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(listSection.count / pageSize)}

                previousLabel={
                  <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                    <BsChevronRight />
                  </span>
                }
                initialPage={savePage - 1}
                containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                activeClassName={
                  savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                }
                // current
              />
                
                </div>
              </div> */}
            </>
          ) : (
            <>
              <div className="w-full flex items-center justify-between">
                <div className="flex w-full font-IranSans items-center ">
                  <label className="text-[15px]">تعداد نمایش در صفحه </label>
                  <select
                    className="border-2 font-IranSans p-1 mr-3 rounded-lg border-gray-400 outline-none"
                    onChange={changePageSize}
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>
                <div className="flex items-center justify-center w-full font-IranSans">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={onChangePageSearch}
                    pageRangeDisplayed={5}
                    pageCount={Math.ceil(SearchResult.count / pageSize)}
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                    // current
                  />
                  {/* <ReactPaginate
                    className="PaginateBody"
                    previousLabel={<GrFormNext size={25} />}
                    nextLabel={<GrFormPrevious size={25} />}
                    breakLabel={'...'}
                    pageCount={Math.ceil(SearchResult.count / pageSize)}
                    marginPagesDisplayed={4}
                    onPageChange={onChangePageSearch}
                    pageClassName={'reactPaginate'}
                    previousClassName={'previous'}
                    nextClassName={'Next'}
                    breakClassName={'break'}
                  /> */}
                </div>
              </div>
            </>
          )}
          {/* modals */}
          {openEdiModal && (
            <>
              {/* <div className="ModalBackground">
                <div className="Modal-innerReform">
                  <div className="w-full ltr">
                    <FaRegWindowClose
                      onClick={() => setOpenEditModal(false)}
                      className="text-[20px] cursor-pointer"
                    />
                  </div>
                  <div className=" text-[18px] font-bold w-full p-2 text-black font-IranSans">
                    اصلاح ساختار
                  </div>

                  <div className="w-full  border-2 border-[#E5E1DA] rounded-lg p-5">
                    <div className="w-full grid grid-cols-2 gap-3 ">
                      <div className="w-full  items-center justify-center flex ">
                        <label className="font-IranSans  mt-3 w-[30%] text-[14px]">
                          نوع ساختار:
                        </label>
                        <select
                          className="w-[70%] border  outline-none border-body p-2 rounded-md font-IranSans"
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              SectionType_ID: parseInt(e.target.value),
                            })
                          }
                        >
                         
                          {sectionType.map((item) => {
                            return item.id === ReformInfo.sectionType_ID ? (
                              <>
                                <option key={item.id} value={item.id} selected>
                                  {item.title}
                                </option>
                              </>
                            ) : (
                              <>
                                {' '}
                                <option key={item.id} value={item.id}>
                                  {item.title}
                                </option>
                              </>
                            );
                          })}
                        </select>
                      </div>
                      <div className="w-full  items-center justify-center flex ">
                        <label className="ml-5 font-IranSans   w-[30%] text-[14px]">
                          سرشاخه :
                        </label>

                        <select
                          className="w-[70%] border outline-none border-body p-2 rounded-md font-IranSans"
                          defaultValue={ReformInfo.SectionPath}
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              Parent_ID:
                                e.target.value === 'null'
                                  ? ''
                                  : parseInt(e.target.value),
                            })
                          }
                        >
                          <option value="null"></option>
                          {Lops.map((item) => {
                            return (
                              <>
                                {item.SectionPath == ReformInfo.SectionPath ? (
                                  <>
                                    <option
                                      key={item.ID}
                                      value={item.ID}
                                      selected
                                    >
                                      {item.SectionPath}
                                    </option>
                                  </>
                                ) : (
                                  <>
                                    <option key={item.ID} value={item.ID}>
                                      {item.SectionPath}
                                    </option>
                                  </>
                                )}
                              </>
                            );
                          })}
                        </select>
                      </div>
                      <div className="w-full  items-center justify-center flex font-IranSans ">
                        <label className="ml-5 w-[30%] mt-3 text-[14px]">
                          عنوان ساختار :
                        </label>
                        <input
                          type="text"
                          defaultValue={ReformInfo.Title}
                          className="w-[70%] border mt-3 outline-none border-body p-3 rounded-md "
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              Title: e.target.value,
                            })
                          }
                        />
                      </div>
                      
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
                          ترتیب :
                        </label>
                        <input
                          defaultValue={ReformInfo.TextOrder}
                          type="text"
                          className="w-[70%] border mt-3 outline-none border-body p-3 rounded-md "
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              TextOrder: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
                           ترتیب ثانویه:
                        </label>
                        <input
                          defaultValue={ReformInfo.TextOrder2}
                          type="text"
                          className="w-[70%] border mt-3 outline-none border-body p-3 rounded-md "
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              TextOrder2: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
تاریخ وضعیت 
                        </label>
                        <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  locale={persian_fa}
                  calendar={persian}
                />
                      </div>
                  
                    <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
وضعیت تنقیحی  
                        </label>
                        <select
                    
                      className="w-[70%] text-[14px] border font-bold outline-none border-body p-1 rounded-md"
                    
                    >
                      {AllStatus.map((item) => {
                        return (
                          <option
                            key={item.id}
                            value={item.id}
                            className="font-bold"
                          >
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                      </div>
                    </div>                 
                       <div className="w-full mt-3 items-center font-IranSans justify-between p-3 flex ">
                      <label className="ml-5  w-[6%] text-[14px]">متن :</label>
                      <div className="w-full h-full font-IranSans ">
                        <CKEditor
                          editor={ClassicEditor}
                          data={ReformInfo.SectionText}
                          onChange={OnChangeCKEitor}
                          config={{
                            language: 'fa',
                          }}
                        />
                      </div>
                    </div>
                    <div className=" flex gap-5 w-full mt-5 ltr p-3 font-IranSans">
                      <button
                        className="w-32 p-2  font-IranSans rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
                        onClick={EditFun}
                      >
                        ثبت
                        <CiEdit size={25} className="ml-2" />
                      </button>
                      <button
                        className="w-32 p-2  font-IranSans rounded-full text-[14px] text-white font-bold flex items-center justify-center
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                        onClick={() => handleDelete(ReformInfo.ID)}
                      >
                        حذف
                        <MdDeleteForever className="ml-3" />
                      </button>
                      <button
                        className="w-32 p-2   font-IranSans rounded-full text-[14px] text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                        onClick={handleOpenCreateModal}
                      >
                        جدید <IoNewspaperOutline className="ml-3" />
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}
              <EditReform EditFun={EditFun} Lops={Lops} />
            </>
          )}
          {openDeleteModalReform && (
            <>
              <div className="ModalBackground">
                <div className="Modal-innerDelete">
                  <FaRegWindowClose
                    onClick={() => setOpenDeleteModalReform(false)}
                    className="top-1"
                  />
                  <p className="w-full mt-3 text-xl text-center">
                    آیا از حذف اطلاعات مطمئن هستنید ؟
                  </p>
                  <div className="flex items-center justify-center w-full  mt-2 ">
                    <button
                      className="w-full border-2 m-2 p-2 rounded-xl bg-[#5D9C59] text-white hover:bg-[#9DC08B]"
                      onClick={deleteAPI}
                    >
                      بله
                    </button>
                    <button
                      className="w-full border-2 m-2 p-2 rounded-xl bg-[#DF2E38] text-white text-xl hover:bg-[#E7AB9A]"
                      onClick={() => setOpenDeleteModalReform(false)}
                    >
                      خیر
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          {EditTextModal && (
            <>
              <div className="ModalBackground">
                <div className="Modal-innerEditText">
                  <FaRegWindowClose onClick={() => setEditTextModal(false)} />
                  <div className=" text-2xl w-full p-2 text-black">
                    ویرایش متن
                  </div>

                  <div className="rtl">
                    <CKEditor
                      editor={ClassicEditor}
                      data={TextEdit.value}
                      onChange={handleCKEditor}
                      config={{
                        language: 'fa',
                      }}
                    />
                  </div>

                  <div className="mt-5 ltr w-full">
                    <button
                      className="w-40 p-2 rounded-full flex items-center justify-center text-2xl hover:border-2 text-white bg-[#65B741] font-bold 
                      hover:shadow-2xl hover:shadow-black "
                      style={{ fontFamily: 'Bmitra' }}
                      onClick={FetchEditText}
                    >
                      ثبت
                      <CiEdit size={30} className="ml-2" />
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          {OpenCreateModal && (
            <>
              <div className="ModalBackground">
                <div className="Modal-innerReform">
                  <div className="w-full ltr">
                    <FaRegWindowClose
                      onClick={() => setOpenCreateModal(false)}
                    />
                  </div>
                  <div className=" text-2xl w-full p-2 text-black">
                    ایجاد ساختار جدید
                  </div>
                  <div className="w-full  border-2 border-[#E5E1DA] rounded-lg p-5">
                    <div className="w-full grid grid-cols-2 gap-10 ">
                      <div className="w-full  items-center justify-center flex ">
                        <label className="ml-5 text-center flex items-center justify-center w-[20%] text-[16px]">
                          نوع ساختار
                        </label>
                        <select
                          className="w-[100%] border-2 mt-5 outline-none border-body p-3 rounded-xl"
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              SectionType_ID: parseInt(e.target.value),
                            })
                          }
                        >
                          {/* <option value="nu"></option> */}
                          {sectionType.map((item) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="w-full  items-center justify-center flex ">
                        <label className="ml-5 text-center flex items-center justify-center w-[20%] text-[16px]">
                          سرشاخه
                        </label>

                        <select
                          className="w-[100%] border-2 mt-5 outline-none border-body p-3 rounded-xl"
                          // defaultValue={ReformInfo.SectionPath}
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              Parent_ID:
                                e.target.value === 'null'
                                  ? ''
                                  : parseInt(e.target.value),
                            })
                          }
                        >
                          <option value="null"></option>
                          {/* <option>{ReformInfo.SectionPath}</option> */}
                          {Lops.map((item) => {
                            return (
                              <option value={item.ID}>
                                {item.SectionPath}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="w-full  items-center justify-center flex ">
                        <label className="ml-5 text-center flex items-center justify-center w-[20%] text-[16px]">
                          عنوان ساختار
                        </label>
                        <input
                          type="text"
                          // defaultValue={ReformInfo.Title}
                          className="w-[100%] border-2 mt-5 outline-none border-body p-3 rounded-xl"
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              Title: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="w-full  items-center justify-center flex ">
                        <label className="ml-5 text-center flex items-center justify-center w-[20%] text-[16px]">
                          ترتیب
                        </label>
                        <input
                          defaultValue={ReformInfo.TextOrder}
                          type="text"
                          className="w-[100%] border-2 mt-5 outline-none border-body p-3 rounded-xl"
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              TextOrder: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                      <div className="w-full  items-center justify-center flex ">
                        <label className="ml-5 text-center flex items-center justify-center w-[20%] text-[16px]">
                          ترتیب ثانویه
                        </label>
                        <input
                          defaultValue={ReformInfo.TextOrder2}
                          type="text"
                          className="w-[100%] border-2 mt-5 outline-none border-body p-3 rounded-xl"
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              TextOrder2: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
                          تاریخ وضعیت
                        </label>
                        <DatePicker
                          className="custom-calendar"
                          inputClass="custom-input"
                          calendarPosition="bottom-center"
                          value={ReformInfo.ChangeDate}
                          locale={persian_fa}
                          calendar={persian}
                          onChange={handleChangeDate}
                        />
                      </div>
                      <div className="w-full font-IranSans  items-center justify-center flex ">
                        <label className="ml-5 mt-3  w-[30%] text-[14px]">
                          وضعیت تنقیحی
                        </label>
                        <select
                          onChange={(e) =>
                            setReformInfo({
                              ...ReformInfo,
                              Status: e.target.value,
                            })
                          }
                          className="w-[70%] text-[14px] border font-bold outline-none border-body p-1 rounded-md"
                        >
                          <option value={null}></option>
                          {AllStatus.map((item) => {
                            return (
                              <option
                                key={item.id}
                                value={item.id}
                                className="font-bold"
                              >
                                {item.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="w-full mt-10 items-center justify-between p-3 flex ">
                      <label className="ml-5  w-[6%] text-xl">متن</label>
                      <div className="w-full">
                        <CKEditor
                          editor={ClassicEditor}
                          // data={ReformInfo.SectionText}
                          onChange={(editor, event) => {
                            setReformInfo({
                              ...ReformInfo,
                              SectionText: event.getData(),
                            });
                          }}
                          config={{
                            language: 'fa',
                          }}
                          className="fixed top-0"
                        />
                      </div>
                      {/* <textarea
                      // defaultValue={ReformInfo.SectionText}
                      rows={5}
                      cols={50}
                      className="w-[100%] h-50 text-2xl  border-2 mt-5 outline-none border-body p-5 rounded-xl"
                      onChange={(e) =>
                        setReformInfo({
                          ...ReformInfo,
                          SectionText: e.target.value,
                        })
                      }
                    /> */}
                    </div>
                    <div className=" flex gap-5 w-full mt-10 ltr p-5">
                      <button
                        className="w-40 p-2 rounded-full text-2xl text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                        style={{ fontFamily: 'IranSans' }}
                        onClick={createStructure}
                      >
                        جدید <IoNewspaperOutline className="ml-3" />
                      </button>
                      {/* <button
                      className="w-40 p-2 rounded-full flex items-center justify-center text-2xl hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
                      style={{ fontFamily: 'Bmitra' }}
                      // onClick={EditFun}
                    >
                      ثبت
                      <CiEdit size={30} className="ml-2" />
                    </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {OpenModalAIRestructure && (
            <>
              <div className="ModalBackground">
                <div className="Modal-innerRestructure">
                  <FaRegWindowClose
                    onClick={() => {
                      setOpenModalAIRestructure(false);
                      setAIstructureLoading(false);
                      setAIShowAlarm(false);
                    }}
                    className="mb-3"
                  />
                  {AIShowAlarm && (
                    <div className="border rounded-md py-14 px-3 flex flex-col">
                      <p className="w-full  text-[18px] font-IranSans text-center font-bold">
                        آیا از ساختار بندی هوشمند اطلاعات مطمئن هستنید ؟
                        <p className="w-full text-[14px] font-medium font-IranSans">
                          (تذکر: همراه با ساختاربندی هوشمند، ساختار فعلی حذف شده
                          و کدگذاری هوشمند و اطلاعات تنقیحی مرتبط نیز مجدد
                          پردازش و ثبت خواهند شد)
                        </p>
                      </p>
                      <div className="w-full font-IranSans  items-center justify-center mt-3 flex ">
                        <input
                          defaultChecked={RevisionRistrict}
                          type="checkbox"
                          className="w-[17px] h-[17px] mt-3 ml-3"
                          onChange={(e) =>
                            setRevisionRistrict(e.target.checked)
                          }
                        />
                        <label className="ml-5 mt-3  text-[14px]">
                          محدودیت تشخیص مواد برای قوانین اثرگذار تنقیحی
                        </label>
                      </div>
                      <div className="w-full font-IranSans px-16   mt-3 flex ">
                        <input
                          defaultChecked={OrderCensitive}
                          type="checkbox"
                          className="w-[17px] h-[17px] mt-3 ml-3"
                          onChange={(e) => setOrderCensitive(e.target.checked)}
                        />
                        <label className="ml-5 mt-3  text-[14px]">
                          حساسیت به ترتیب مواد
                        </label>
                      </div>
                      <div className="flex items-center justify-center w-full  mt-4 ">
                        <button
                          // id='startProcess'
                          className="w-[30%] shadow-xl border hover:bg-[#ffffff] hover:text-[#5D9C59] font-IranSans border-2 m-2 p-2 rounded-xl bg-[#5D9C59] text-white hover:bg-[#9DC08B]"
                          onClick={AIstructure}
                          // onClick={()=>setAIstructureLoading(true)}
                        >
                          بله
                        </button>
                        <button
                          className="w-[30%] shadow-xl border hover:bg-[#ffffff] hover:text-[#DF2E38] font-IranSans border-2 m-2 p-2 rounded-xl bg-[#DF2E38] text-white  hover:bg-[#E7AB9A]"
                          onClick={() => setOpenDeleteModal(false)}
                        >
                          خیر
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="w-full flex flex-col h-full">
                    {AIstructureLoading && (
                      <div className="w-full flex items-center justify-center">
                        <div className="loader"></div>
                      </div>

                      // <section className="dots-container">
                      //   <div className="dot"></div>
                      //   <div className="dot"></div>
                      //   <div className="dot"></div>
                      //   <div className="dot"></div>
                      //   <div className="dot"></div>
                      // </section>
                    )}
                    <div className="mt-5 w-full flex-col flex items-center justify-center font-IranSans">
                      {Message &&
                        Message.map((item) => {
                          return (
                            <div className="flex items-center w-full justify-between">
                              <img src={tickIMG} className="w-8 h-8 mr-2" />
                              <div className="w-full  text-[15px]">{item}</div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default NewReform;
